import { useLocation, Navigate } from "react-router";

import type { ReactNode } from "react";
import { useAuth } from "@/hooks/use-auth";

const GuestGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const path = location?.state?.redirectPath || "/dashboard";
  if (isAuthenticated) return <Navigate to={path} />;
  return <>{children}</>;
};

export default GuestGuard;
